import { ServiceName } from '../enum/service-name.enum';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddButtonExcludedServices: string[] = [ServiceName.sophosMsp, ServiceName.barracudaMsp];
